import { useState, forwardRef, ForwardedRef, useImperativeHandle } from "react";
import { UnsavedChangesModal } from "./editQuiz";

export type UnsavedChangesModalWrapperRef = {
	open: () => void;
	close: () => void;
};

type Props = {
	onConfirm: () => void;
};

export const UnsavedChangesModalWrapper = forwardRef(function UnsavedChangesModalWrapper(
	{ onConfirm }: Props,
	ref: ForwardedRef<UnsavedChangesModalWrapperRef>,
) {
	const [openModal, setOpenModal] = useState(false);

	useImperativeHandle(ref, () => ({
		open: () => setOpenModal(true),
		close: () => setOpenModal(false),
	}));

	return <UnsavedChangesModal openModal={openModal} onClose={() => setOpenModal(false)} onConfirm={onConfirm} inLms />;
});

export default UnsavedChangesModalWrapper;
